module.exports = __webpack_public_path__ + "img/c-1.6a1f9cc4.png";